var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticStyle:{"text-align":"right"},attrs:{"id":'label_' + _vm.parameterKey}},[_c('strong',[_vm._v(" "+_vm._s(this.labelTextFormatter(_vm.parameterKey, _vm.parameterValue))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }